import PropTypes from 'prop-types';
import { compose, setPropTypes, withProps, mapProps } from 'recompose';
import { connect } from 'react-redux';

import StaffingCompanyRecord from './record';
import * as selectors from './selectors';
import { Endpoints } from '../../lib/LeanLinkService';
import withPagination from '../../components/PaginatedItems/withPagination';
import requireProps from '../../lib/requireProps';

function mapStateToProps(state, { staffingCompanyIds }) {
  return {
    staffingCompanies: selectors.staffingCompaniesByIds(state, staffingCompanyIds),
  };
}

const withStaffingCompanies = compose(
  setPropTypes({
    staffingCompanyIds: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
  }),
  connect,
  setPropTypes({
    staffingCompanies: PropTypes.arrayOf(PropTypes.instanceOf(StaffingCompanyRecord)),
  }),
)(mapStateToProps);

export default (fetchData) => {
  if (fetchData) {
    return compose(
      withProps(() => ({
        url: Endpoints.staffingCompanies.list(),
      })),
      withPagination(),
      requireProps(['ids']),
      mapProps(({ ids, ...props }) => ({
        ...props,
        staffingCompanyIds: ids,
      })),
      withStaffingCompanies,
    );
  }
  return withStaffingCompanies;
};
